import { useState } from "react";
import { Send, PhoneCall, Clock3, MapPin } from "lucide-react";
import { toast } from "sonner";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { waLink, WA_DISPLAY } from "../config";

const KATEGORI = ["Darurat Kesehatan", "Laporan Infrastruktur", "Ide Komunitas", "Kritik & Saran"];

const inputCls =
  "w-full rounded-xl border border-line bg-surfacewarm px-4 py-3.5 text-sm text-ink placeholder:text-soft/70 outline-none transition-all focus:border-terra focus:ring-2 focus:ring-terra/20";

export const AspirasiForm = () => {
  const [form, setForm] = useState({ nama: "", rtrw: "", kategori: KATEGORI[0], pesan: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const msg = [
      "*ASPIRASI WARGA CIANJAY*",
      "",
      `Nama: ${form.nama}`,
      `Asal RT/RW: ${form.rtrw}`,
      `Kategori: ${form.kategori}`,
      "",
      "Pesan:",
      form.pesan,
    ].join("\n");
    window.open(waLink(msg), "_blank", "noopener");
    toast.success("Aspirasi siap dikirim!", {
      description: "WhatsApp terbuka dengan pesan Anda. Tinggal tekan kirim, sampai langsung ke meja Pak Kades.",
    });
  };

  return (
    <section id="aspirasi" data-testid="aspirasi-section" className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <SectionHeading
            bab="Bab 06"
            label="Pojok Aspirasi & Kontak"
            title="Suaramu Menentukan Arah Cianjay"
            sub="Punya keluhan, kritik, atau ide cemerlang untuk kemajuan desa kita? Sampaikan langsung ke meja saya."
            testid="aspirasi"
          />
          <div className="mt-10 space-y-4">
            {[
              { icon: PhoneCall, label: "WhatsApp Langsung", value: WA_DISPLAY },
              { icon: Clock3, label: "Jam Layanan", value: "24 Jam · 7 Hari · Tanpa Libur" },
              { icon: MapPin, label: "Balai Desa Cianjay", value: "Kecamatan Cianjir" },
            ].map((c, i) => (
              <Reveal key={i} delay={0.15 + i * 0.08}>
                <div className="flex items-center gap-4 rounded-2xl border border-line bg-surface px-5 py-4" data-testid={`aspirasi-contact-${i}`}>
                  <span className="grid place-items-center w-10 h-10 rounded-xl bg-badge text-terra shrink-0">
                    <c.icon size={18} />
                  </span>
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-soft">{c.label}</p>
                    <p className="text-sm font-semibold mt-0.5">{c.value}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.2} y={50}>
            <form
              onSubmit={submit}
              data-testid="aspiration-form"
              className="rounded-[2rem] border border-line bg-surface p-6 sm:p-10 shadow-[0_24px_60px_rgba(30,58,43,0.12)]"
            >
              <div className="grid sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="f-nama" className="block font-mono text-[11px] uppercase tracking-[0.18em] text-soft mb-2">Nama Lengkap</label>
                  <input id="f-nama" data-testid="aspiration-input-nama" required value={form.nama} onChange={set("nama")} placeholder="Contoh: Budi Santoso" className={inputCls} />
                </div>
                <div>
                  <label htmlFor="f-rtrw" className="block font-mono text-[11px] uppercase tracking-[0.18em] text-soft mb-2">Asal RT/RW</label>
                  <input id="f-rtrw" data-testid="aspiration-input-rtrw" required value={form.rtrw} onChange={set("rtrw")} placeholder="Contoh: RT 02 / RW 01" className={inputCls} />
                </div>
              </div>
              <div className="mt-5">
                <label htmlFor="f-kategori" className="block font-mono text-[11px] uppercase tracking-[0.18em] text-soft mb-2">Kategori</label>
                <select id="f-kategori" data-testid="aspiration-select-kategori" value={form.kategori} onChange={set("kategori")} className={inputCls}>
                  {KATEGORI.map((k) => <option key={k} value={k}>{k}</option>)}
                </select>
              </div>
              <div className="mt-5">
                <label htmlFor="f-pesan" className="block font-mono text-[11px] uppercase tracking-[0.18em] text-soft mb-2">Pesan/Aspirasi Anda</label>
                <textarea id="f-pesan" data-testid="aspiration-textarea-pesan" required rows={5} value={form.pesan} onChange={set("pesan")} placeholder="Sampaikan aspirasimu secara jujur dan santun..." className={`${inputCls} resize-none`} />
              </div>
              <button
                type="submit"
                data-testid="aspiration-form-submit-button"
                className="group mt-7 inline-flex w-full sm:w-auto items-center justify-center gap-2.5 rounded-full bg-terra px-8 py-4 text-sm sm:text-base font-semibold text-white transition-all hover:-translate-y-1 hover:bg-terra/90 shadow-[0_14px_35px_rgba(200,90,50,0.3)]"
              >
                <Send size={17} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-0.5" />
                Kirim Aspirasi ke Pak Kades
              </button>
              <p className="mt-4 text-xs text-soft">Terkirim langsung ke WhatsApp pribadi Pak Kades. Tanpa perantara, tanpa menunggu jam kantor.</p>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
